import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './FormRow.module.scss';

function FormRow({
  description,
  hideLabel,
  required,
  children,
  modifier,
  label,
  id,
}) {
  return (
    <div className={classNames(styles.container, modifier && styles[modifier])}>
      {label && (
        <label
          className={classNames(styles.label, hideLabel && 'u-visually-hidden')}
          htmlFor={id}
        >
          <span className={styles.labelInner}>{label}</span>
          {required && '*'}
        </label>
      )}

      {/* Description and label can not be shown at the same time (styling) */}
      {!label && description && (
        <p className={styles.label}>
          {description}
          {required && '*'}
        </p>
      )}

      {children}
    </div>
  );
}

FormRow.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  hideLabel: PropTypes.bool,
  modifier: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default FormRow;
